import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { textFieldDefaultStyle } from '../../components/UI/Typography';

export const EditButton = styled(Button)(({ theme }) => ({
  width: 210,
  height: 32,
  border: `1.5px solid ${theme.palette.secondary.main}`,
  borderRadius: 10,
  color: theme.palette.secondary.main,
  fontWeight: 600,
  backgroundColor: '#FAFCFF',
  display: 'flex',
  gap: 8,
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  margin: '20px 0',
  '& span': { color: theme.palette.secondary.main },
}));

export const StyledInput = styled(Typography)(() => ({
  fontWeight: '600',
  fontSize: '18px',
  borderBottom: '1px solid #8B8C8E',
  inlineSize: 'fit-content',
  minWidth: '180px',
  paddingLeft: '8px',
  minHeight: '28px',
}));

export const InputTitle = styled(Typography)(() => ({
  paddingBottom: '4px',
  fontSize: '14px',
}));

export const ButtonContainer = styled(Box)(() => ({
  margin: '20px 0',
  display: 'flex',
  justifyContent: 'space-around',
  gap: '40px',
}));

export const ButtonDownloadBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '20px',
}));

export const ButtonTitle = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: '600',
  padding: '10px',
}));

export const DownloadButton = styled(Button)(() => ({
  display: 'flex',
  gap: '10px',
}));

type UploadButtonProps = {
  component: string;
};

export const UploadButton = styled(Button)<UploadButtonProps>(
  ({ component }) => ({
    display: 'flex',
    gap: '10px',
    component,
  })
);

export const SmallStyledInput = styled(Typography)(() => ({
  fontWeight: '600',
  fontSize: '18px',
  borderBottom: '1px solid #8B8C8E',
  inlineSize: 'fit-content',
  minWidth: '100px',
  paddingLeft: '8px',
  minHeight: '28px',
}));

export const ConservationButton = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  width: '100%',
  border: `2px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  fontWeight: '600',
  lineHeight: '20px',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const ApproveButton = styled(Button)(() => ({
  borderRadius: '10px',
  width: '100%',
}));

export const SubmitBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '60px 0',
  gap: '40px',
}));

export const ConfirmButton = styled(Button)(({ theme }) => ({
  minWidth: '250px',
  backgroundColor: '#FAFCFF',
  border: `2px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  fontWeight: '600',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
  [theme.breakpoints.down('lg')]: {
    minWidth: '180px',
    maxWidth: '200px',
  },
}));

export const StyledGrid = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const SliderGrid = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const SampleButton = styled(Button)(({ theme }) => ({
  width: '240px',
  borderRadius: '10px',
  backgroundColor: theme.palette.secondary.main,
  display: 'flex',
  gap: '10px',
  '&:hover': {
    filter: 'brightness(85%)',
  },
  '@media (max-width: 1800px)': {
    width: '220px',
  },
}));

export const StyledTextField = styled(TextField)(() => ({
  ...textFieldDefaultStyle,
  width: '100px',
  '& .MuiInputBase-input': { padding: '14px' },
}));

export const ExtrapolationsErrors = styled(Box)(() => ({
  width: '100%',
  padding: '8px 0',
  margin: '50px 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  background: '#F5F7FB',
  border: '1px solid #FF334B',
  color: '#FF334B',
  fontSize: 21,
  fontWeight: 600,

  '& p': {
    fontSize: 14,
    fontWeight: 400,
  },
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
  },
}));

export const DialogBox = styled(Box)(() => ({
  minWidth: '600px',
  minHeight: '200px',
  padding: '40px',
}));

export const CloseIcon = styled(IconButton)(({ theme }) => ({
  margin: '-30px -30px 0',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const DialogTypography = styled(Typography)(() => ({
  textAlign: 'center',
  fontSize: '18px',
  fontWeight: '600',
  color: '#595959',
}));
